/**
 * Hero - 页面主视觉区域组件
 * 包含大标题、副标题、CTA按钮、应用截图
 */
export class Hero {
  constructor(options = {}) {
    this.title = options.title || '';
    this.subtitle = options.subtitle || '';
    this.ctaText = options.ctaText || '免费下载';
    this.ctaLink = options.ctaLink || '#';
    this.ctaIcon = options.ctaIcon || '';
    this.ctaExternal = options.ctaExternal !== false;
    this.secondaryText = options.secondaryText || '';
    this.secondaryLink = options.secondaryLink || '#';
    this.secondaryIcon = options.secondaryIcon || '';
    this.image = options.image || '';
    this.imageAlt = options.imageAlt || 'App Screenshot';
  }

  render() {
    const section = document.createElement('section');
    section.className = 'hero section';

    const externalAttrs = (link) =>
      /^https?:\/\//i.test(link)
        ? ' target="_blank" rel="noopener noreferrer"'
        : '';

    // 图标放在文字前，用 span 包裹以便控制基线与尺寸
    const iconSpan = (icon) =>
      icon ? `<span class="btn__emoji" aria-hidden="true">${icon}</span>` : '';

    const primaryBtn = `<a href="${this.ctaLink}" class="btn btn--primary btn--lg"${externalAttrs(this.ctaLink)}>${iconSpan(this.ctaIcon)}<span>${this.ctaText}</span></a>`;
    const secondaryBtn = this.secondaryText
      ? `<a href="${this.secondaryLink}" class="btn btn--ghost btn--lg"${externalAttrs(this.secondaryLink)}>${iconSpan(this.secondaryIcon)}<span>${this.secondaryText}</span></a>`
      : '';

    section.innerHTML = `
      <div class="container">
        <div class="hero__inner grid grid--2">
          <div class="hero__content flex flex--col">
            <h1 class="heading-xl">${this.title}</h1>
            <p class="text-muted hero__subtitle">${this.subtitle}</p>
            <div class="hero__actions">
              ${primaryBtn}
              ${secondaryBtn}
            </div>
          </div>
          <div class="hero__visual">
            ${this.image ? `<img src="${this.image}" alt="${this.imageAlt}" />` : ''}
          </div>
        </div>
      </div>
    `;
    return section;
  }
}
